export default function getSubdomain() {
  const matches = window.location.hostname.match(/^([^.]+)\./);

  return matches ? matches[1] : 'admin';
}
